import { Button, Stack } from '@mui/material';
import React, { useCallback, useContext } from 'react';
import { accountEntityReferenceAutocompletePersonOnlyFilter } from '../../../../../person/person';
import ContactFormWidget from '../../../../../production/resource/orders/editor/resourceOrderApprovalsStep/ContactFormWidget';
import { ENTITY_CONSTANTS } from '../../../../constants/entityConstants';
import { FormContext, FormContextType } from '../../../../form/FormContext';
import I18n from '../../../../i18n/I18n';
import type { ShareSettingsFormState } from '../../../types';
import { useInternalShareSettings } from '../../hooks/useInternalShareSettings';
import { mergeActorsToAddIntoSharedWith } from '../../utils';

export interface ShareActorSelectionFormFieldProps {
    allowAddingShareActors?: boolean;
}

export default function ShareActorSelectionFormField({
    allowAddingShareActors = false
}: ShareActorSelectionFormFieldProps) {
    const { state, handleChange } = useContext<FormContextType<ShareSettingsFormState>>(FormContext);
    const { shareSettings, updateShareSettingsState } = useInternalShareSettings();

    const handleAdd = () => {
        updateShareSettingsState({
            sharedWith: mergeActorsToAddIntoSharedWith(
                shareSettings.sharedWith,
                state.actorsToAddToSharedWith,
                state.defaultAction
            )
        });
        handleChange('actorsToAddToSharedWith', []);
    };

    const handleCancel = useCallback(() => {
        handleChange('actorsToAddToSharedWith', []);
    }, [handleChange]);

    return (
        <>
            <ContactFormWidget
                name="actorsToAddToSharedWith"
                labelToken="common.search.for.people"
                filter={accountEntityReferenceAutocompletePersonOnlyFilter}
                entity={ENTITY_CONSTANTS.account}
                showEmail
                addOption={allowAddingShareActors}
            />
            {state.actorsToAddToSharedWith.length > 0 && (
                <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 1, width: '100%' }}>
                    <Button variant="text" onClick={handleCancel}>
                        <I18n token="dialog.cancel" />
                    </Button>
                    <Button variant="outlined" onClick={handleAdd}>
                        <I18n token="button.add" />
                    </Button>
                </Stack>
            )}
        </>
    );
}
